import manager_menu_ru from "../../images/landing/ru/manager_menu.png";
import manager_billing_ru from "../../images/landing/ru/manager_billing.png";
import manager_members_ru from "../../images/landing/ru/manager_members.png";
import manager_attendance_ru from "../../images/landing/ru/manager_attendance.png";
import manager_tournaments_ru from "../../images/landing/ru/manager_tournaments.png";
import manager_game_teams_ru from "../../images/landing/ru/manager_game_teams.png";
import manager_games_ru from "../../images/landing/ru/manager_games.png";
import training_groups_ru from "../../images/landing/ru/training_groups.png";
import bot_trainer_ru from "../../images/landing/ru/bot_trainer.png";
import bot_trainer_trainings_ru from "../../images/landing/ru/bot_trainer_trainings.png";
import bot_manager_approve_ru from "../../images/landing/ru/bot_manager_approve.png";
import bot_settings_ru from "../../images/landing/ru/bot_settings.png";
import bot_parent_game_ru from "../../images/landing/ru/bot_parent_game.png";
import parent_game_result_ru from "../../images/landing/ru/parent_game_result.png";

import manager_menu_kg from "../../images/landing/kg/manager_menu.png";
import manager_billing_kg from "../../images/landing/kg/manager_billing.png";
import manager_members_kg from "../../images/landing/kg/manager_members.png";
import manager_attendance_kg from "../../images/landing/kg/manager_attendance.png";
import manager_tournaments_kg from "../../images/landing/kg/manager_tournaments.png";
import manager_game_teams_kg from "../../images/landing/kg/manager_game_teams.png";
import manager_games_kg from "../../images/landing/kg/manager_games.png";
import training_groups_kg from "../../images/landing/kg/training_groups.png";
import bot_trainer_kg from "../../images/landing/kg/bot_trainer.png";
import bot_trainer_trainings_kg from "../../images/landing/kg/bot_trainer_trainings.png";
import bot_manager_approve_kg from "../../images/landing/kg/bot_manager_approve.png";
import bot_settings_kg from "../../images/landing/kg/bot_settings.png";
import bot_parent_game_kg from "../../images/landing/kg/bot_parent_game.png";
import parent_game_result_kg from "../../images/landing/kg/parent_game_result.png";

import manager_menu_kz from "../../images/landing/kz/manager_menu.png";
import manager_billing_kz from "../../images/landing/kz/manager_billing.png";
import manager_members_kz from "../../images/landing/kz/manager_members.png";
import manager_attendance_kz from "../../images/landing/kz/manager_attendance.png";
import manager_tournaments_kz from "../../images/landing/kz/manager_tournaments.png";
import manager_game_teams_kz from "../../images/landing/kz/manager_game_teams.png";
import manager_games_kz from "../../images/landing/kz/manager_games.png";
import training_groups_kz from "../../images/landing/kz/training_groups.png";
import bot_trainer_kz from "../../images/landing/kz/bot_trainer.png";
import bot_trainer_trainings_kz from "../../images/landing/kz/bot_trainer_trainings.png";
import bot_manager_approve_kz from "../../images/landing/kz/bot_manager_approve.png";
import bot_settings_kz from "../../images/landing/kz/bot_settings.png";
import bot_parent_game_kz from "../../images/landing/kz/bot_parent_game.png";
import parent_game_result_kz from "../../images/landing/kz/parent_game_result.png";

import manager_menu_uz from "../../images/landing/uz/manager_menu.png";
import manager_billing_uz from "../../images/landing/uz/manager_billing.png";
import manager_members_uz from "../../images/landing/uz/manager_members.png";
import manager_attendance_uz from "../../images/landing/uz/manager_attendance.png";
import manager_tournaments_uz from "../../images/landing/uz/manager_tournaments.png";
import manager_game_teams_uz from "../../images/landing/uz/manager_game_teams.png";
import manager_games_uz from "../../images/landing/uz/manager_games.png";
import training_groups_uz from "../../images/landing/uz/training_groups.png";
import bot_trainer_uz from "../../images/landing/uz/bot_trainer.png";
import bot_trainer_trainings_uz from "../../images/landing/uz/bot_trainer_trainings.png";
import bot_manager_approve_uz from "../../images/landing/uz/bot_manager_approve.png";
import bot_settings_uz from "../../images/landing/uz/bot_settings.png";
import bot_parent_game_uz from "../../images/landing/uz/bot_parent_game.png";
import parent_game_result_uz from "../../images/landing/uz/parent_game_result.png";

import manager_menu_en from "../../images/landing/en/manager_menu.png";
import manager_billing_en from "../../images/landing/en/manager_billing.png";
import manager_members_en from "../../images/landing/en/manager_members.png";
import manager_attendance_en from "../../images/landing/en/manager_attendance.png";
import manager_tournaments_en from "../../images/landing/en/manager_tournaments.png";
import manager_game_teams_en from "../../images/landing/en/manager_game_teams.png";
import manager_games_en from "../../images/landing/en/manager_games.png";
import training_groups_en from "../../images/landing/en/training_groups.png";
import bot_trainer_en from "../../images/landing/en/bot_trainer.png";
import bot_trainer_trainings_en from "../../images/landing/en/bot_trainer_trainings.png";
import bot_manager_approve_en from "../../images/landing/en/bot_manager_approve.png";
import bot_settings_en from "../../images/landing/en/bot_settings.png";
import bot_parent_game_en from "../../images/landing/en/bot_parent_game.png";
import parent_game_result_en from "../../images/landing/en/parent_game_result.png";

export const BOT_URL = "https://t.me/clubnumberone_bot";

export const LANG_OPTIONS = [
  { id: "ru", name: "RU" },
  { id: "kg", name: "KG" },
  { id: "kz", name: "KZ" },
  { id: "uz", name: "UZ" },
  { id: "en", name: "EN" },
];

const screensByLang = {
  ru: {
    hero: {
      title: "Меню менеджера",
      src: manager_menu_ru,
      alt: "Меню менеджера",
    },
    modules: [
      { title: "Участники клуба", src: manager_members_ru, alt: "Участники клуба" },
      { title: "Группы и тренировки", src: training_groups_ru, alt: "Группы и тренировки" },
      { title: "Начисления и оплаты", src: manager_billing_ru, alt: "Начисления и оплаты" },
      { title: "Игры клуба", src: manager_games_ru, alt: "Игры клуба" },
    ],
    roles: [
      { title: "Тренер в Telegram", src: bot_trainer_ru, alt: "Тренер в Telegram" },
      { title: "Тренировки тренера", src: bot_trainer_trainings_ru, alt: "Тренировки тренера" },
    ],
    attendance: [
      { title: "Посещаемость менеджера", src: manager_attendance_ru, alt: "Посещаемость менеджера" },
      { title: "Подтверждение в Telegram", src: bot_manager_approve_ru, alt: "Подтверждение в Telegram" },
    ],
    tournaments: [
      { title: "Турниры менеджера", src: manager_tournaments_ru, alt: "Турниры менеджера" },
      { title: "Игровые команды", src: manager_game_teams_ru, alt: "Игровые команды" },
    ],
    rating: [
      { title: "Результаты для родителей", src: parent_game_result_ru, alt: "Результаты для родителей" },
      { title: "Игра в Telegram для родителя", src: bot_parent_game_ru, alt: "Игра в Telegram для родителя" },
    ],
    analytics: [
      { title: "Настройки в Telegram", src: bot_settings_ru, alt: "Настройки в Telegram" },
    ],
  },

  kg: {
    hero: {
      title: "Меню менеджера",
      src: manager_menu_kg,
      alt: "Меню менеджера",
    },
    modules: [
      { title: "Клуб мүчөлөрү", src: manager_members_kg, alt: "Клуб мүчөлөрү" },
      { title: "Топтор жана машыгуулар", src: training_groups_kg, alt: "Топтор жана машыгуулар" },
      { title: "Эсептөөлөр жана төлөмдөр", src: manager_billing_kg, alt: "Эсептөөлөр жана төлөмдөр" },
      { title: "Клуб оюндары", src: manager_games_kg, alt: "Клуб оюндары" },
    ],
    roles: [
      { title: "Машыктыруучу Telegram'да", src: bot_trainer_kg, alt: "Машыктыруучу Telegram'да" },
      { title: "Машыктыруучунун машыгуулары", src: bot_trainer_trainings_kg, alt: "Машыктыруучунун машыгуулары" },
    ],
    attendance: [
      { title: "Катышуу", src: manager_attendance_kg, alt: "Катышуу" },
      { title: "Telegram'да тастыктоо", src: bot_manager_approve_kg, alt: "Telegram'да тастыктоо" },
    ],
    tournaments: [
      { title: "Турнирлер", src: manager_tournaments_kg, alt: "Турнирлер" },
      { title: "Оюн командалары", src: manager_game_teams_kg, alt: "Оюн командалары" },
    ],
    rating: [
      { title: "Ата-энелер үчүн жыйынтыктар", src: parent_game_result_kg, alt: "Ата-энелер үчүн жыйынтыктар" },
      { title: "Ата-эне үчүн Telegram оюну", src: bot_parent_game_kg, alt: "Ата-эне үчүн Telegram оюну" },
    ],
    analytics: [
      { title: "Telegram'дагы жөндөөлөр", src: bot_settings_kg, alt: "Telegram'дагы жөндөөлөр" },
    ],
  },

  kz: {
    hero: {
      title: "Менеджер мәзірі",
      src: manager_menu_kz,
      alt: "Менеджер мәзірі",
    },
    modules: [
      { title: "Клуб мүшелері", src: manager_members_kz, alt: "Клуб мүшелері" },
      { title: "Топтар мен жаттығулар", src: training_groups_kz, alt: "Топтар мен жаттығулар" },
      { title: "Есептеулер мен төлемдер", src: manager_billing_kz, alt: "Есептеулер мен төлемдер" },
      { title: "Клуб ойындары", src: manager_games_kz, alt: "Клуб ойындары" },
    ],
    roles: [
      { title: "Жаттықтырушы Telegram-да", src: bot_trainer_kz, alt: "Жаттықтырушы Telegram-да" },
      { title: "Жаттықтырушы жаттығулары", src: bot_trainer_trainings_kz, alt: "Жаттықтырушы жаттығулары" },
    ],
    attendance: [
      { title: "Қатысу", src: manager_attendance_kz, alt: "Қатысу" },
      { title: "Telegram-да растау", src: bot_manager_approve_kz, alt: "Telegram-да растау" },
    ],
    tournaments: [
      { title: "Турнирлер", src: manager_tournaments_kz, alt: "Турнирлер" },
      { title: "Ойын командалары", src: manager_game_teams_kz, alt: "Ойын командалары" },
    ],
    rating: [
      { title: "Ата-аналарға арналған нәтижелер", src: parent_game_result_kz, alt: "Ата-аналарға арналған нәтижелер" },
      { title: "Ата-ана үшін Telegram ойыны", src: bot_parent_game_kz, alt: "Ата-ана үшін Telegram ойыны" },
    ],
    analytics: [
      { title: "Telegram-дағы баптаулар", src: bot_settings_kz, alt: "Telegram-дағы баптаулар" },
    ],
  },

  uz: {
    hero: {
      title: "Menejer menyusi",
      src: manager_menu_uz,
      alt: "Menejer menyusi",
    },
    modules: [
      { title: "Klub a’zolari", src: manager_members_uz, alt: "Klub a’zolari" },
      { title: "Guruhlar va mashg‘ulotlar", src: training_groups_uz, alt: "Guruhlar va mashg‘ulotlar" },
      { title: "Hisob-kitob va to‘lovlar", src: manager_billing_uz, alt: "Hisob-kitob va to‘lovlar" },
      { title: "Klub o‘yinlari", src: manager_games_uz, alt: "Klub o‘yinlari" },
    ],
    roles: [
      { title: "Murabbiy Telegram’da", src: bot_trainer_uz, alt: "Murabbiy Telegram’da" },
      { title: "Murabbiy mashg‘ulotlari", src: bot_trainer_trainings_uz, alt: "Murabbiy mashg‘ulotlari" },
    ],
    attendance: [
      { title: "Davomat", src: manager_attendance_uz, alt: "Davomat" },
      { title: "Telegram’da tasdiqlash", src: bot_manager_approve_uz, alt: "Telegram’da tasdiqlash" },
    ],
    tournaments: [
      { title: "Turnirlar", src: manager_tournaments_uz, alt: "Turnirlar" },
      { title: "O‘yin jamoalari", src: manager_game_teams_uz, alt: "O‘yin jamoalari" },
    ],
    rating: [
      { title: "Ota-onalar uchun natijalar", src: parent_game_result_uz, alt: "Ota-onalar uchun natijalar" },
      { title: "Ota-ona uchun Telegram o‘yini", src: bot_parent_game_uz, alt: "Ota-ona uchun Telegram o‘yini" },
    ],
    analytics: [
      { title: "Telegram sozlamalari", src: bot_settings_uz, alt: "Telegram sozlamalari" },
    ],
  },

  en: {
    hero: {
      title: "Manager menu",
      src: manager_menu_en,
      alt: "Manager menu",
    },
    modules: [
      { title: "Club members", src: manager_members_en, alt: "Club members" },
      { title: "Groups and trainings", src: training_groups_en, alt: "Groups and trainings" },
      { title: "Billing and payments", src: manager_billing_en, alt: "Billing and payments" },
      { title: "Club games", src: manager_games_en, alt: "Club games" },
    ],
    roles: [
      { title: "Coach in Telegram", src: bot_trainer_en, alt: "Coach in Telegram" },
      { title: "Coach trainings", src: bot_trainer_trainings_en, alt: "Coach trainings" },
    ],
    attendance: [
      { title: "Attendance", src: manager_attendance_en, alt: "Attendance" },
      { title: "Telegram confirmation", src: bot_manager_approve_en, alt: "Telegram confirmation" },
    ],
    tournaments: [
      { title: "Tournaments", src: manager_tournaments_en, alt: "Tournaments" },
      { title: "Game teams", src: manager_game_teams_en, alt: "Game teams" },
    ],
    rating: [
      { title: "Results for parents", src: parent_game_result_en, alt: "Results for parents" },
      { title: "Telegram game for parent", src: bot_parent_game_en, alt: "Telegram game for parent" },
    ],
    analytics: [
      { title: "Telegram settings", src: bot_settings_en, alt: "Telegram settings" },
    ],
  },
};

const ruText = {
  nav: [
    { id: "modules", label: "Модули" },
    { id: "roles", label: "Роли" },
    { id: "tournaments", label: "Турниры" },
    { id: "trial", label: "14 дней бесплатно" },
    { id: "pricing", label: "Тарифы" },
    { id: "faq", label: "FAQ" },
    { id: "ai", label: "ИИ" },
    { id: "referral", label: "Акция" },
  ],

  hero: {
    kicker: "Club #1 — Telegram платформа",
    title: "Управляйте клубом, посещаемостью, оплатами, играми и турнирами в одной цифровой системе",
    paragraphs: [
      "Club #1 объединяет ключевые процессы спортивного клуба: группы, участники, посещаемость, начисления, оплаты, игры, турниры, награды, медиа и аналитику.",
      "Вы можете работать в Telegram-боте, в Telegram Web App на смартфоне и в обычном браузере на компьютере.",
      "Менеджеры и тренеры могут входить через токен из Telegram-бота без сложной авторизации.",
      "Club #1 AI помогает находить спортивные клубы и отвечает на вопросы менеджеров, тренеров и участников — с учётом их прав доступа.",
    ],
    button: "Начать через Telegram",
    pills: [
      "Без паролей",
      "Telegram Web App + браузер",
      "Посещаемость вручную или по фото",
      "Турниры и игровые команды",
      "Оплаты и начисления",
      "Аналитика и отчёты",
      "ИИ-помощник и поиск клубов",
    ],
  },

  modules: {
    kicker: "Модули платформы",
    title: "Все ключевые процессы клуба — в одной системе",
    text: "Club #1 помогает собрать ежедневную работу клуба, тренеров, родителей и участников в одном цифровом пространстве.",
    cards: [
      { icon: "👥", title: "Члены клуба", desc: "Профили, контакты, статусы, история и медиа." },
      { icon: "🧩", title: "Группы", desc: "Составы, расписание, тренеры и возрастные категории." },
      { icon: "✅", title: "Посещаемость", desc: "Ручная отметка и автоматизация через фото." },
      { icon: "💳", title: "Оплаты", desc: "Начисления, задолженности, чеки и подтверждения." },
      { icon: "⚽", title: "Игры", desc: "Составы, участники, результаты и статистика." },
      { icon: "🏆", title: "Турниры", desc: "Организация, приглашения, команды и участие." },
      { icon: "🎖️", title: "Рейтинг", desc: "Награды, достижения, рейтинги игроков и клуба." },
      { icon: "📈", title: "Аналитика", desc: "Отчёты по посещаемости, оплатам и активности." },
      { icon: "🤖", title: "Club #1 AI", desc: "Поиск клубов, ответы по участникам, посещаемости и оплатам в рамках прав доступа." },
    ],
  },

  roles: {
    kicker: "Роли и доступы",
    title: "Каждой роли — свой сценарий работы",
    items: [
      { title: "Менеджер", desc: "Управление клубом, оплатами, турнирами, медиа и настройками." },
      { title: "Тренер", desc: "Посещаемость, тренировки, составы, игры и участие в турнирах." },
      { title: "Родитель", desc: "Расписание, оплаты, достижения и уведомления ребёнка." },
      { title: "Участник", desc: "Профиль, игры, рейтинг, награды и активность." },
      { title: "СММ", desc: "Публичные страницы, рейтинг, награды и контент клуба." },
    ],
  },

  attendance: {
    kicker: "Посещаемость",
    title: "От ручной отметки до распознавания лица по групповому фото",
    paragraphs: [
      "Тренер может отмечать посещаемость вручную через Telegram-кнопки и веб-кабинет.",
      "В расширенном режиме можно загрузить групповое фото, а система заранее отметит найденных участников.",
      "При первой посещаемости участника в месяце начисление может создаваться автоматически.",
    ],
  },

  tournaments: {
    kicker: "Турниры",
    title: "Создание турниров, приглашения клубов и игровые команды",
    text: "Club #1 позволяет организовывать турниры внутри системы: приглашать клубы, собирать команды, вести игры, результаты и участие.",
  },

  rating: {
    kicker: "Рейтинг и достижения",
    title: "Публичная спортивная история клуба и участников",
    text: "Награды, результаты, достижения и медиа формируют доверие к клубу и усиливают вовлечённость родителей и игроков.",
  },

  analytics: {
    kicker: "Аналитика",
    title: "Управленческие показатели по клубу",
    text: "Следите за посещаемостью, оплатами, долгами, активностью групп и общей картиной развития клуба.",
    stats: [
      { value: "24/7", label: "доступ к системе" },
      { value: "1", label: "единая платформа" },
      { value: "5+", label: "ролей пользователей" },
    ],
  },
  ai: {
  "kicker": "Club #1 AI",
  "title": "Управляйте клубом и находите секции с помощью ИИ",
  "text": "Достаточно написать вопрос обычным языком в Telegram. ИИ помогает искать клубы и работать с данными вашего клуба — без длинных меню и сложных фильтров.",
  "cards": [
    {
      "icon": "🔎",
      "title": "Умный поиск клубов",
      "desc": "Найдите секцию по виду спорта, городу или названию. Поиск доступен даже без привязки телефона."
    },
    {
      "icon": "💬",
      "title": "Помощник менеджера",
      "desc": "Спросите про задолженности, участников и посещаемость — только по клубу, к которому у вас есть доступ."
    },
    {
      "icon": "🧑‍🏫",
      "title": "Помощник тренера и родителей",
      "desc": "Информация по тренировкам, группам и оплатам с учётом роли пользователя."
    },
    {
      "icon": "🛟",
      "title": "Живая поддержка",
      "desc": "Если ИИ не решил вопрос, можно обратиться напрямую в Club #1 Support."
    }
  ],
  "button": "Попробовать ИИ в Telegram",
  "searchButton": "Найти спортивный клуб"
},

  trial: {
  "kicker": "14 дней Pro бесплатно · пробный доступ",
  "title": "Попробуйте Pro 14 дней без оплаты",
  "text": "Проверьте, как Club #1 помогает вашему клубу: AI-помощник, распознавание лиц по фото, посещаемость, начисления и турниры. Банковская карта не нужна.",
  "features": [
    "Все функции Pro на время теста",
    "До 100 AI-запросов на клуб за пробный период",
    "После теста можно остаться на бесплатном Starter"
  ],
  "button": "Попробовать через Telegram",
  "note": "Пробный период будет доступен после внедрения системы подписок. Условия и лимиты пробного доступа могут уточняться."
},

  priceUi: {
  "monthly": "/ месяц",
  "free": "Бесплатно",
  "country": "Валюта для просмотра",
  "localEstimate": "≈ {amount}",
  "fxLoading": "Загружаем ориентировочный курс…",
  "fxNoRate": "Стоимость в местной валюте пока недоступна. Цена в USD остаётся основной.",
  "fxDisclaimer": "Местные суммы ориентировочные и рассчитываются по справочному курсу. Валюта и окончательная сумма оплаты будут подтверждены перед списанием.",
  "ratesAttribution": "Курсы: Exchange Rate API",
  "offer": "Цены предложены для запуска. Платные подписки, пробный период и покупка AI-пакетов будут подключены позднее."
},

  pricing: {
  "kicker": "Тарифы",
  "title": "Прозрачные тарифы для клубов любого размера",
  "text": "Четыре уровня — от бесплатного Starter до Club+. Попробуйте Pro 14 дней без оплаты после запуска пробного доступа. Каждый тариф включает месячную квоту AI-запросов клуба.",
  "notice": "Цены предложены для запуска. Платные подписки, пробный период и покупка AI-пакетов будут подключены позднее.",
  "plans": [
    {
      "name": "Starter",
      "price": "$0",
      "priceUsd": 0,
      "badge": "Для небольших клубов",
      "description": "Основные процессы клуба без абонентской платы.",
      "features": [
        "До 50 участников",
        "50 AI-запросов клуба в месяц",
        "Группы и расписание",
        "Ручная посещаемость",
        "Начисления, оплаты и задолженности",
        "Базовые игры и составы"
      ],
      "notIncluded": [
        "Распознавание лиц",
        "Участие в турнирах",
        "Расширенные отчёты"
      ]
    },
    {
      "name": "Beginner",
      "price": "$12",
      "priceUsd": 12,
      "badge": "Для растущих клубов",
      "description": "Больше участников, турниры и полноценная отчётность.",
      "features": [
        "До 150 участников",
        "300 AI-запросов клуба в месяц",
        "Всё из Starter",
        "Участие в турнирах",
        "Расширенные отчёты",
        "Увеличенные личные AI-лимиты"
      ],
      "notIncluded": [
        "Распознавание лиц",
        "AI-аналитика"
      ]
    },
    {
      "name": "Pro",
      "price": "$29",
      "priceUsd": 29,
      "badge": "Для активных клубов",
      "highlight": true,
      "description": "Автоматизация посещаемости и AI-аналитика.",
      "features": [
        "До 500 участников",
        "1 500 AI-запросов клуба в месяц",
        "Всё из Beginner",
        "Распознавание лиц по фото",
        "AI-аналитика",
        "Расширенные отчёты"
      ],
      "notIncluded": []
    },
    {
      "name": "Club+",
      "price": "$59",
      "priceUsd": 59,
      "badge": "Для сетей и академий",
      "description": "Максимум возможностей для крупных спортивных организаций.",
      "features": [
        "Без фиксированного лимита участников",
        "2 000 AI-запросов клуба в месяц",
        "Всё из Pro",
        "Распознавание лиц",
        "Турниры и AI-аналитика",
        "Расширенные отчёты"
      ],
      "notIncluded": []
    }
  ]
},

  packages: {
  "kicker": "Дополнительный ИИ",
  "title": "Нужны ещё AI-запросы?",
  "text": "Когда клубу не хватает месячного лимита, можно дополнительно приобрести пакет AI-запросов. Покупка пакетов появится после подключения оплаты.",
  "cards": [
    {
      "name": "AI 100",
      "price": "$5",
      "priceUsd": 5,
      "detail": "100 дополнительных AI-запросов"
    },
    {
      "name": "AI 500",
      "price": "$19",
      "priceUsd": 19,
      "detail": "500 дополнительных AI-запросов"
    },
    {
      "name": "AI 1500",
      "price": "$45",
      "priceUsd": 45,
      "detail": "1 500 дополнительных AI-запросов"
    }
  ],
  "note": "Цены предложены для запуска. Покупка пакетов ещё не подключена; срок действия и правила списания уточним при запуске.",
  "button": "Уточнить условия покупки"
},

  referral: {
  "kicker": "Реферальная программа · скоро",
  "title": "Пригласи клуб — получи 100% его первого платежа",
  "text": "Пригласите новый спортивный клуб в Club #1. Когда он впервые оплатит подписку после пробного периода, на ваш внутренний баланс Club #1 будет начислен бонус в размере 100% этой оплаты.",
  "steps": [
    "Пригласи знакомый клуб",
    "Клуб зарегистрируется и оплатит подписку впервые",
    "Получи эквивалент первой оплаты на баланс Club #1"
  ],
  "note": "Акция анонсирована заранее. Начисление бонусов, правила участия и использование баланса будут доступны после запуска программы. Бонус — внутренний баланс, не денежный вывод.",
  "button": "Узнать о запуске"
},

  faq: {
  kicker: "FAQ",
  title: "Часто задаваемые вопросы",
  items: [
    {
      q: "Нужно ли устанавливать приложение?",
      a: "Нет. Club #1 работает в Telegram-боте, Telegram Web App и обычном браузере.",
    },
    {
      q: "Можно ли вести оплаты и посещаемость?",
      a: "Да. Это один из базовых сценариев системы.",
    },
    {
      q: "Подходит ли для турниров?",
      a: "Да. Можно создавать турниры, приглашать клубы и собирать игровые команды.",
    },
    {
      q: "Для кого эта система?",
      a: "Для спортивных клубов, академий, тренеров и организаторов турниров, которым важно управлять участниками, оплатами, играми и развитием игроков в одной системе.",
    },
    {
      q: "Есть ещё вопросы?",
      a: "Напишите в поддержку: <a href='https://t.me/club1_support' target='_blank'>@Club1 Support</a>",
    },

    {
      "q": "Есть ли ИИ и на каком языке он отвечает?",
      "a": "Да. Club #1 AI понимает запросы на русском, кыргызском и других поддерживаемых языках. Публичный поиск клубов и работа с данными клуба разделены."
    },
    {
      "q": "Как работают AI-лимиты?",
      "a": "Каждый тариф содержит общую месячную квоту AI-запросов клуба. Для ролей предусмотрены также персональные ограничения. Публичный поиск не расходует квоту клуба."
    },
    {
      "q": "Можно ли купить дополнительные AI-запросы?",
      "a": "Для этого предусмотрены дополнительные AI-пакеты. Доступность и условия покупки уточняйте в <a href=\"https://t.me/club1_support\" target=\"_blank\" rel=\"noopener noreferrer\">Club #1 Support</a>."
    },
    {
      "q": "Уже работает акция «Пригласи клуб»?",
      "a": "Реферальная программа анонсирована, но автоматическое начисление бонусов пока разрабатывается. О запуске сообщим отдельно."
    },
    {
      "q": "Есть ли бесплатный пробный период?",
      "a": "Для новых клубов предусмотрен 14-дневный доступ к Pro без банковской карты. Запуск пробного периода ожидается вместе с системой подписок. После окончания можно использовать бесплатный Starter."
    },
    {
      "q": "В какой валюте указаны цены?",
      "a": "Базовая цена — в долларах США (USD). Вы можете выбрать страну и увидеть ориентировочную сумму в KGS, RUB, KZT или UZS. Фактическая валюта и сумма оплаты подтверждаются при оформлении."
    }
  ],
},

  cta: {
    kicker: "Готовы начать?",
    title: "Попробуйте Club #1 в Telegram",
    text: "Откройте Club #1 в Telegram: управляйте клубом, найдите спортивную секцию или попробуйте AI-помощника.",
    button: "Открыть бота",
  },

  footer: {
    text: "Цифровая платформа для спортивных клубов",
  },
};

const kgText = {
  nav: [
    { id: "modules", label: "Модулдар" },
    { id: "roles", label: "Ролдор" },
    { id: "tournaments", label: "Турнирлер" },
    { id: "trial", label: "14 күн акысыз" },
    { id: "pricing", label: "Тарифтер" },
    { id: "faq", label: "FAQ" },
    { id: "ai", label: "ЖИ" },
    { id: "referral", label: "Акция" },
  ],

  hero: {
    kicker: "Club #1 — Telegram платформасы",
    title: "Клубду, катышууну, төлөмдөрдү, оюндарды жана турнирлерди бир санариптик системада башкарыңыз",
    paragraphs: [
      "Club #1 спорт клубунун негизги процесстерин бириктирет: топтор, катышуучулар, катышуу, эсептөөлөр, төлөмдөр, оюндар, турнирлер, сыйлыктар, медиа жана аналитика.",
      "Сиз Telegram-ботто, смартфондогу Telegram Web App’та жана компьютердеги браузерде иштей аласыз.",
      "Менеджерлер жана машыктыруучулар Telegram-боттон алынган токен аркылуу татаал авторизациясыз кире алышат.",
      "Club #1 AI спорт клубдарын табууга жана менеджерлердин, машыктыруучулардын, катышуучулардын суроолоруна жооп берүүгө жардам берет.",
    ],
    button: "Telegram аркылуу баштоо",
    pills: [
      "Сырсөзсүз",
      "Telegram Web App + браузер",
      "Катышуу кол менен же фото аркылуу",
      "Турнирлер жана командалар",
      "Төлөмдөр жана эсептөөлөр",
      "Аналитика жана отчеттор",
      "ЖИ-жардамчы жана клуб издөө",
    ],
  },

  modules: {
    kicker: "Платформанын модулдары",
    title: "Клубдун бардык негизги процесстери — бир системада",
    text: "Club #1 клубдун, машыктыруучулардын, ата-энелердин жана катышуучулардын күнүмдүк ишин бир санариптик мейкиндикте бириктирет.",
    cards: [
      { icon: "👥", title: "Клуб мүчөлөрү", desc: "Профильдер, байланыштар, статус, тарых жана медиа." },
      { icon: "🧩", title: "Топтор", desc: "Курам, график, машыктыруучулар жана жаш категориялар." },
      { icon: "✅", title: "Катышуу", desc: "Кол менен белгилөө жана фото аркылуу автоматташтыруу." },
      { icon: "💳", title: "Төлөмдөр", desc: "Эсептөөлөр, карыздар, чектер жана тастыктоо." },
      { icon: "⚽", title: "Оюндар", desc: "Курам, катышуучулар, жыйынтыктар жана статистика." },
      { icon: "🏆", title: "Турнирлер", desc: "Уюштуруу, чакыруу, командалар жана катышуу." },
      { icon: "🎖️", title: "Рейтинг", desc: "Сыйлыктар, жетишкендиктер жана рейтингдер." },
      { icon: "📈", title: "Аналитика", desc: "Катышуу, төлөм жана активдүүлүк боюнча отчеттор." },
      { icon: "🤖", title: "Club #1 AI", desc: "Клубдарды издөө, катышуу, төлөмдөр жана мүчөлөр боюнча ролго ылайык жооптор." },
    ],
  },

  roles: {
    kicker: "Ролдор жана жеткиликтүүлүк",
    title: "Ар бир роль үчүн өзүнүн иш сценарийи",
    items: [
      { title: "Менеджер", desc: "Клубду, төлөмдөрдү, турнирлерди жана жөндөөлөрдү башкаруу." },
      { title: "Машыктыруучу", desc: "Катышуу, машыгуу, курам жана оюндар." },
      { title: "Ата-эне", desc: "График, төлөмдөр жана баланын жетишкендиктери." },
      { title: "Катышуучу", desc: "Профиль, оюндар жана рейтинг." },
      { title: "SMM", desc: "Контент жана коомдук барактар." },
    ],
  },

  attendance: {
    kicker: "Катышуу",
    title: "Кол менен белгилөөдөн тартып бет таанууга чейин",
    paragraphs: [
      "Машыктыруучу катышууну кол менен белгилей алат.",
      "Фото жүктөп автоматтык белгилөө мүмкүн.",
      "Биринчи катышууда автоматтык эсептөө түзүлүшү мүмкүн.",
    ],
  },

  tournaments: {
    kicker: "Турнирлер",
    title: "Турнир түзүү жана клубдарды чакыруу",
    text: "Командаларды түзүү, оюндарды жүргүзүү жана жыйынтыктарды көзөмөлдөө.",
  },

  rating: {
    kicker: "Рейтинг жана жетишкендиктер",
    title: "Клубдун коомдук тарыхы",
    text: "Жетишкендиктер жана медиа клубга ишенимди жогорулатат.",
  },

  analytics: {
    kicker: "Аналитика",
    title: "Клубдун көрсөткүчтөрү",
    text: "Катышуу, төлөм жана активдүүлүк боюнча маалыматтар.",
    stats: [
      { value: "24/7", label: "жеткиликтүүлүк" },
      { value: "1", label: "платформа" },
      { value: "5+", label: "ролдор" },
    ],
  },
  ai: {
  "kicker": "Club #1 AI",
  "title": "Жасалма интеллект менен клубду башкарыңыз жана секция табыңыз",
  "text": "Telegram аркылуу суроону кадимки тилде бериңиз. ЖИ клубдарды издейт жана сиздин укуктарыңыздын алкагында клубдун маалыматын талдоого жардам берет.",
  "cards": [
    {
      "icon": "🔎",
      "title": "Клубдарды акылдуу издөө",
      "desc": "Спорттун түрү, шаар же аталышы боюнча секция табыңыз. Телефон номери жок да издөөгө болот."
    },
    {
      "icon": "💬",
      "title": "Менеджердин жардамчысы",
      "desc": "Карыздар, катышуучулар жана катышуу жөнүндө өз клубуңуздун чегинде сураңыз."
    },
    {
      "icon": "🧑‍🏫",
      "title": "Машыктыруучу жана ата-эне үчүн",
      "desc": "Ролуңузга жараша машыгуу, топтор жана төлөмдөр жөнүндө маалымат."
    },
    {
      "icon": "🛟",
      "title": "Түз колдоо",
      "desc": "ЖИ жардам бере албаса, Club #1 Support менен түз байланышыңыз."
    }
  ],
  "button": "Telegram аркылуу ЖИни сынап көрүү",
  "searchButton": "Спорт клубун табуу"
},

  trial: {
  "kicker": "14 күн Pro акысыз · сыноо мөөнөтү",
  "title": "Pro мүмкүнчүлүктөрүн 14 күн акысыз сынаңыз",
  "text": "Club #1 клубуңузга кандай жардам берерин көрүңүз: ЖИ-жардамчы, фото аркылуу бет таануу, катышуу, эсептөөлөр жана турнирлер. Банк картасы талап кылынбайт.",
  "features": [
    "Сыноо учурунда Pro мүмкүнчүлүктөрү",
    "Сыноо мезгилинде клубга 100гө чейин ЖИ-суроо",
    "Андан кийин акысыз Starter тарифинде калсаңыз болот"
  ],
  "button": "Telegram аркылуу сынап көрүү",
  "note": "Сыноо мөөнөтү жазылуу системасы киргизилгенден кийин жеткиликтүү болот. Шарттар жана лимиттер такталышы мүмкүн."
},

  priceUi: {
  "monthly": "/ ай",
  "free": "Акысыз",
  "country": "Көрсөтүлүүчү валюта",
  "localEstimate": "≈ {amount}",
  "fxLoading": "Болжолдуу курс жүктөлүүдө…",
  "fxNoRate": "Жергиликтүү валютадагы баа азырынча жеткиликтүү эмес. Негизги баа USD менен.",
  "fxDisclaimer": "Жергиликтүү сумма маалымат үчүн гана, справкалык курс менен эсептелет. Төлөмдүн валютасы жана акыркы суммасы төлөөрдөн мурун көрсөтүлөт.",
  "ratesAttribution": "Курс булагы: Exchange Rate API",
  "offer": "Баалар сунуш катары көрсөтүлгөн. Акы төлөнүүчү жазылуу, сыноо мөөнөтү жана ЖИ-топтомдорун сатып алуу кийин иштетилет."
},

  pricing: {
  "kicker": "Тарифтер",
  "title": "Ар бир спорт клубу үчүн ыңгайлуу тариф",
  "text": "Акысыз Starter тарифинен Club+ деңгээлине чейин төрт план. Сыноо иштетилгенде Pro кызматын 14 күн акысыз пайдаланыңыз. Ар бир тарифте айлык ЖИ-суроо лимити бар.",
  "notice": "Баалар сунуш катары көрсөтүлгөн. Акы төлөнүүчү жазылуу, сыноо мөөнөтү жана ЖИ-топтомдорун сатып алуу кийин иштетилет.",
  "plans": [
    {
      "name": "Starter",
      "price": "$0",
      "priceUsd": 0,
      "badge": "Чакан клубдар үчүн",
      "description": "Ай сайын акы төлөбөстөн негизги башкаруу.",
      "features": [
        "50 катышуучуга чейин",
        "Айына 50 ЖИ-суроо",
        "Топтор жана график",
        "Кол менен катышууну белгилөө",
        "Эсептөөлөр, төлөмдөр жана карыздар",
        "Оюндар жана курамдар"
      ],
      "notIncluded": [
        "Бет таануу",
        "Турнирлерге катышуу",
        "Кеңейтилген отчеттор"
      ]
    },
    {
      "name": "Beginner",
      "price": "$12",
      "priceUsd": 12,
      "badge": "Өсүп жаткан клубдар үчүн",
      "description": "Көбүрөөк катышуучу, турнирлер жана отчеттор.",
      "features": [
        "150 катышуучуга чейин",
        "Айына 300 ЖИ-суроо",
        "Starter мүмкүнчүлүктөрү",
        "Турнирлерге катышуу",
        "Кеңейтилген отчеттор",
        "Жеке ЖИ-лимиттери кеңейтилген"
      ],
      "notIncluded": [
        "Бет таануу",
        "ЖИ-аналитика"
      ]
    },
    {
      "name": "Pro",
      "price": "$29",
      "priceUsd": 29,
      "badge": "Активдүү клубдар үчүн",
      "highlight": true,
      "description": "Катышууну автоматташтыруу жана ЖИ-аналитика.",
      "features": [
        "500 катышуучуга чейин",
        "Айына 1 500 ЖИ-суроо",
        "Beginner мүмкүнчүлүктөрү",
        "Сүрөт аркылуу бет таануу",
        "ЖИ-аналитика",
        "Кеңейтилген отчеттор"
      ],
      "notIncluded": []
    },
    {
      "name": "Club+",
      "price": "$59",
      "priceUsd": 59,
      "badge": "Академиялар үчүн",
      "description": "Ири спорт уюмдарына кеңири мүмкүнчүлүк.",
      "features": [
        "Катышуучулардын саны чектелбейт",
        "Айына 2 000 ЖИ-суроо",
        "Pro мүмкүнчүлүктөрү",
        "Бет таануу",
        "Турнирлер жана ЖИ-аналитика",
        "Кеңейтилген отчеттор"
      ],
      "notIncluded": []
    }
  ]
},

  packages: {
  "kicker": "Кошумча ЖИ",
  "title": "Дагы ЖИ-суроолор керекпи?",
  "text": "Клубдун айлык ЖИ-лимити жетпесе, кошумча суроо топтомун сатып алууга болот. Сатып алуу төлөм системасы кошулгандан кийин ачылат.",
  "cards": [
    {
      "name": "AI 100",
      "price": "$5",
      "priceUsd": 5,
      "detail": "100 кошумча ЖИ-суроо"
    },
    {
      "name": "AI 500",
      "price": "$19",
      "priceUsd": 19,
      "detail": "500 кошумча ЖИ-суроо"
    },
    {
      "name": "AI 1500",
      "price": "$45",
      "priceUsd": 45,
      "detail": "1 500 кошумча ЖИ-суроо"
    }
  ],
  "note": "Баалар сунуш катары көрсөтүлгөн. Топтомдорду сатып алуу азырынча иштетиле элек; шарттар кийин такталат.",
  "button": "Сатып алуу шарттарын билүү"
},

  referral: {
  "kicker": "Чакыруу программасы · жакында",
  "title": "Клуб чакыр — анын биринчи төлөмүнүн 100% ал",
  "text": "Club #1 кызматына жаңы спорт клубун чакырыңыз. Ал сыноо мөөнөтүнөн кийин жазылууну биринчи жолу төлөгөндө, ошол төлөмдүн 100%ына барабар бонус ички Club #1 балансыңызга түшөт.",
  "steps": [
    "Тааныш спорт клубун чакырыңыз",
    "Клуб катталып, биринчи төлөмүн жасайт",
    "Биринчи төлөмгө тең бонусту Club #1 балансына алыңыз"
  ],
  "note": "Программа азырынча жарыяланды. Бонустарды эсептөө жана колдонуу эрежелери ишке киргенден кийин жеткиликтүү болот. Бонус — ички баланс, накталай алынбайт.",
  "button": "Ишке кирүүсү жөнүндө билүү"
},

  faq: {
  kicker: "FAQ",
  title: "Көп берилүүчү суроолор",
  items: [
    {
      q: "Колдонмону орнотуу керекпи?",
      a: "Жок. Club #1 Telegram-ботто, Telegram Web App’та жана кадимки браузерде иштейт.",
    },
    {
      q: "Төлөмдөрдү жана катышууну жүргүзсө болобу?",
      a: "Ооба. Бул системанын негизги сценарийлеринин бири.",
    },
    {
      q: "Турнирлер үчүн ылайыктуубу?",
      a: "Ооба. Турнирлерди түзүп, клубдарды чакырып жана оюн командаларын түзсө болот.",
    },
    {
      q: "Бул система кимдер үчүн?",
      a: "Спорт клубдары, академиялар, машыктыруучулар жана турнир уюштуруучулар үчүн — катышуучуларды, төлөмдөрдү, оюндарды жана оюнчулардын өнүгүүсүн бир системада башкаруу үчүн.",
    },
    {
      q: "Дагы суроолоруңуз барбы?",
      a: "Бул жакка жазыңыз: <a href='https://t.me/club1_support' target='_blank'>@Club1 Support</a>"
    },

    {
      "q": "ЖИ кайсы тилдерде жооп берет?",
      "a": "Club #1 AI кыргыз, орус жана башка колдоого алынган тилдердеги суроолорду түшүнөт. Клуб издөө менен ички маалымат өзүнчө иштейт."
    },
    {
      "q": "ЖИ-лимиттер кандай иштейт?",
      "a": "Ар бир тарифтин клуб боюнча жалпы айлык ЖИ-суроо лимити бар. Ар бир роль үчүн жеке лимит да каралган. Коомдук издөө клубдун лимитин коротпойт."
    },
    {
      "q": "Кошумча ЖИ-суроолорду сатып алса болобу?",
      "a": "Кошумча ЖИ-топтомдору каралган. Сатып алуунун шарттарын <a href=\"https://t.me/club1_support\" target=\"_blank\" rel=\"noopener noreferrer\">Club #1 Support</a> аркылуу тактаңыз."
    },
    {
      "q": "«Клуб чакыр» акциясы азыр иштейби?",
      "a": "Чакыруу программасы жарыяланды, бирок бонустарды автоматтык эсептөө азырынча иштелип жатат."
    },
    {
      "q": "Акысыз сыноо мөөнөтү барбы?",
      "a": "Жаңы клубдар үчүн банк картасыз 14 күн Pro сыноо мөөнөтү каралган. Бул мүмкүнчүлүк жазылуу системасы менен кошо ишке кирет. Андан кийин акысыз Starter колдонсо болот."
    },
    {
      "q": "Баалар кайсы валютада көрсөтүлгөн?",
      "a": "Негизги баа АКШ долларында (USD). Өлкөнү тандап, KGS, RUB, KZT же UZS менен болжолдуу бааны көрө аласыз. Акыркы сумма төлөм алдында көрсөтүлөт."
    }
  ],
},

  cta: {
    kicker: "Даярсызбы?",
    title: "Club #1 колдонуп көрүңүз",
    text: "Club #1 кызматын Telegram аркылуу ачыңыз: клубду башкарыңыз, секция табыңыз же ЖИ жардамчыны сынаңыз.",
    button: "Ботту ачуу",
  },

  footer: {
    text: "Спорт клубдар үчүн платформа",
  },
};

const enText = {
  nav: [
    { id: "modules", label: "Modules" },
    { id: "roles", label: "Roles" },
    { id: "tournaments", label: "Tournaments" },
    { id: "trial", label: "14-day free trial" },
    { id: "pricing", label: "Pricing" },
    { id: "faq", label: "FAQ" },
    { id: "ai", label: "AI" },
    { id: "referral", label: "Refer & earn" },
  ],

  hero: {
    kicker: "Club #1 — Telegram platform",
    title: "Manage your club, attendance, payments, games and tournaments in one digital system",
    paragraphs: [
      "Club #1 integrates key sports club processes: groups, members, attendance, accruals, payments, games, tournaments, awards, media, and analytics.",
      "You can work in Telegram bot, Telegram Web App on mobile, and in a browser on desktop.",
      "Managers and coaches log in via Telegram token without complex authorization.",
      "Club #1 AI helps discover sports clubs and answers questions for managers, coaches and members, with role-based access controls.",
    ],
    button: "Start via Telegram",
    pills: [
      "No passwords",
      "Telegram Web App + browser",
      "Attendance manual or via photo",
      "Tournaments and teams",
      "Payments and billing",
      "Analytics and reports",
      "AI assistant and club discovery",
    ],
  },

  modules: {
    kicker: "Platform modules",
    title: "All key club processes in one system",
    text: "Club #1 brings daily work of club, coaches, parents and players into one digital space.",
    cards: [
      { icon: "👥", title: "Members", desc: "Profiles, contacts, statuses, history and media." },
      { icon: "🧩", title: "Groups", desc: "Lineups, schedules and categories." },
      { icon: "✅", title: "Attendance", desc: "Manual tracking and photo automation." },
      { icon: "💳", title: "Payments", desc: "Billing, debts and confirmations." },
      { icon: "⚽", title: "Games", desc: "Lineups, results and stats." },
      { icon: "🏆", title: "Tournaments", desc: "Organization and participation." },
      { icon: "🎖️", title: "Rating", desc: "Achievements and rankings." },
      { icon: "📈", title: "Analytics", desc: "Reports and insights." },
      { icon: "🤖", title: "Club #1 AI", desc: "Find clubs and ask role-aware questions about attendance, payments and members." },
    ],
  },

  roles: {
    kicker: "Roles and access",
    title: "Each role has its own workflow",
    items: [
      { title: "Manager", desc: "Club, payments and settings." },
      { title: "Coach", desc: "Attendance and games." },
      { title: "Parent", desc: "Schedule and progress." },
      { title: "Member", desc: "Profile and activity." },
      { title: "SMM", desc: "Content and public pages." },
    ],
  },

  attendance: {
    kicker: "Attendance",
    title: "From manual marking to face recognition",
    paragraphs: [
      "Manual attendance marking.",
      "Automatic via group photo.",
      "Auto billing possible.",
    ],
  },

  tournaments: {
    kicker: "Tournaments",
    title: "Create tournaments and invite clubs",
    text: "Manage teams, games and results.",
  },

  rating: {
    kicker: "Rating and achievements",
    title: "Public club history",
    text: "Achievements build trust.",
  },

  analytics: {
    kicker: "Analytics",
    title: "Club metrics",
    text: "Track performance.",
    stats: [
      { value: "24/7", label: "access" },
      { value: "1", label: "platform" },
      { value: "5+", label: "roles" },
    ],
  },
  ai: {
  "kicker": "Club #1 AI",
  "title": "Manage your club and discover training with AI",
  "text": "Ask questions in everyday language via Telegram. AI can find clubs and help with the data you are authorized to access, without navigating complex menus.",
  "cards": [
    {
      "icon": "🔎",
      "title": "Smart club discovery",
      "desc": "Search by sport, city or club name, even before sharing a phone number."
    },
    {
      "icon": "💬",
      "title": "Manager assistant",
      "desc": "Ask about outstanding balances, members and attendance within your selected club."
    },
    {
      "icon": "🧑‍🏫",
      "title": "Coach and parent assistant",
      "desc": "Role-aware information about training, groups and billing."
    },
    {
      "icon": "🛟",
      "title": "Human support",
      "desc": "If AI cannot help, contact Club #1 Support directly."
    }
  ],
  "button": "Try AI in Telegram",
  "searchButton": "Find a sports club"
},

  trial: {
  "kicker": "14 days of Pro free · trial",
  "title": "Try Club #1 Pro free for 14 days",
  "text": "See how Club #1 works for your team: AI assistant, photo face recognition, attendance, billing, and tournaments. No credit card required.",
  "features": [
    "Access to Pro features during the trial",
    "Up to 100 club AI requests for the trial",
    "Keep using free Starter after the trial"
  ],
  "button": "Try it via Telegram",
  "note": "Trial access will become available when subscriptions launch. Trial terms and limits may be adjusted."
},

  priceUi: {
  "monthly": "/ month",
  "free": "Free",
  "country": "Show price in",
  "localEstimate": "≈ {amount}",
  "fxLoading": "Loading indicative exchange rates…",
  "fxNoRate": "Local currency estimates are temporarily unavailable. USD is the base price.",
  "fxDisclaimer": "Local amounts are indicative conversions at reference exchange rates. Final payment currency and amount will be confirmed before checkout.",
  "ratesAttribution": "Rates by Exchange Rate API",
  "offer": "Prices are proposed for launch. Paid subscriptions, trials, and AI pack purchases will be activated later."
},

  pricing: {
  "kicker": "Pricing",
  "title": "Straightforward pricing for clubs of every size",
  "text": "Four plans from free Starter to Club+. Try Pro free for 14 days when trial access launches. Every plan includes a monthly shared club AI request allowance.",
  "notice": "Prices are proposed for launch. Paid subscriptions, trials, and AI pack purchases will be activated later.",
  "plans": [
    {
      "name": "Starter",
      "price": "$0",
      "priceUsd": 0,
      "badge": "Small clubs",
      "description": "Core club management at no monthly charge.",
      "features": [
        "Up to 50 members",
        "50 club AI requests / month",
        "Groups and schedules",
        "Manual attendance",
        "Billing, payments and debts",
        "Basic games and squads"
      ],
      "notIncluded": [
        "Face recognition",
        "Tournament participation",
        "Advanced reports"
      ]
    },
    {
      "name": "Beginner",
      "price": "$12",
      "priceUsd": 12,
      "badge": "Growing clubs",
      "description": "More members, tournaments and reporting.",
      "features": [
        "Up to 150 members",
        "300 club AI requests / month",
        "Everything in Starter",
        "Tournament participation",
        "Advanced reports",
        "Higher individual AI allowances"
      ],
      "notIncluded": [
        "Face recognition",
        "AI analytics"
      ]
    },
    {
      "name": "Pro",
      "price": "$29",
      "priceUsd": 29,
      "badge": "Active clubs",
      "highlight": true,
      "description": "Automated attendance and AI-driven insights.",
      "features": [
        "Up to 500 members",
        "1,500 club AI requests / month",
        "Everything in Beginner",
        "Photo-based face recognition",
        "AI analytics",
        "Advanced reporting"
      ],
      "notIncluded": []
    },
    {
      "name": "Club+",
      "price": "$59",
      "priceUsd": 59,
      "badge": "Academies and networks",
      "description": "Maximum capacity for large sports organizations.",
      "features": [
        "No fixed member cap",
        "2,000 club AI requests / month",
        "Everything in Pro",
        "Face recognition",
        "Tournaments and AI analytics",
        "Advanced reporting"
      ],
      "notIncluded": []
    }
  ]
},

  packages: {
  "kicker": "Extra AI",
  "title": "Need more AI requests?",
  "text": "Need more AI requests than your plan includes? Additional request packs will be available once payment functionality launches.",
  "cards": [
    {
      "name": "AI 100",
      "price": "$5",
      "priceUsd": 5,
      "detail": "100 additional AI requests"
    },
    {
      "name": "AI 500",
      "price": "$19",
      "priceUsd": 19,
      "detail": "500 additional AI requests"
    },
    {
      "name": "AI 1500",
      "price": "$45",
      "priceUsd": 45,
      "detail": "1,500 additional AI requests"
    }
  ],
  "note": "These are proposed launch prices. AI pack purchases are not yet live; validity and usage terms will be confirmed at launch.",
  "button": "Ask about AI packs"
},

  referral: {
  "kicker": "Referral program · coming soon",
  "title": "Invite a club. Earn 100% of its first payment.",
  "text": "Invite a new sports club to Club #1. When that club makes its first subscription payment after its trial, you will receive a credit equal to 100% of that payment in your Club #1 internal balance.",
  "steps": [
    "Invite a sports club",
    "The club signs up and makes its first payment",
    "Receive an equal bonus in your Club #1 balance"
  ],
  "note": "Announced in advance. Bonus tracking, eligibility rules and balance spending will be available once the program launches. This is platform credit, not cash withdrawal.",
  "button": "Ask about launch"
},

  faq: {
  kicker: "FAQ",
  title: "Frequently asked questions",
  items: [
    {
      q: "Do I need to install an app?",
      a: "No. Club #1 works in a Telegram bot, Telegram Web App, and a regular browser.",
    },
    {
      q: "Can I manage payments and attendance?",
      a: "Yes. This is one of the core use cases of the system.",
    },
    {
      q: "Is it suitable for tournaments?",
      a: "Yes. You can create tournaments, invite clubs, and manage teams.",
    },
    {
      q: "Who is this system for?",
      a: "For sports clubs, academies, coaches, and tournament organizers who need to manage members, payments, games, and player development in one system.",
    },
    {
      q: "Have more questions?",
      a: "Contact support : <a href='https://t.me/club1_support' target='_blank'>@Club1 Support</a>",
    },

    {
      "q": "What languages does the AI assistant support?",
      "a": "Club #1 AI understands Kyrgyz, Russian and other supported languages. Public club discovery and internal club data are isolated."
    },
    {
      "q": "How do AI limits work?",
      "a": "Each plan includes a shared monthly club AI allowance plus role-specific individual limits. Public club searches do not consume club allowances."
    },
    {
      "q": "Can I buy extra AI requests?",
      "a": "Additional request packs are planned in the offering. Ask <a href=\"https://t.me/club1_support\" target=\"_blank\" rel=\"noopener noreferrer\">Club #1 Support</a> about availability and purchase terms."
    },
    {
      "q": "Is the referral promotion active already?",
      "a": "The referral program has been announced, but automatic bonus crediting is still in development."
    },
    {
      "q": "Is there a free trial?",
      "a": "A 14-day Pro trial without a credit card is planned for new clubs. It will launch alongside subscriptions. You can keep using free Starter afterwards."
    },
    {
      "q": "Which currency are prices shown in?",
      "a": "Base prices are in US dollars (USD). Choose a country to see indicative KGS, RUB, KZT or UZS amounts. Final payment currency and price are confirmed at checkout."
    }
  ],
},

  cta: {
    kicker: "Ready to start?",
    title: "Try Club #1",
    text: "Open Club #1 in Telegram: manage your club, discover sports clubs, or try the AI assistant.",
    button: "Open bot",
  },

  footer: {
    text: "Digital platform for sports clubs",
  },
};

const uzText = {
  nav: [
    { id: "modules", label: "Modullar" },
    { id: "roles", label: "Rollar" },
    { id: "tournaments", label: "Turnirlar" },
    { id: "trial", label: "14 kun bepul" },
    { id: "pricing", label: "Tariflar" },
    { id: "faq", label: "FAQ" },
    { id: "ai", label: "AI" },
    { id: "referral", label: "Aksiya" },
  ],

  hero: {
    kicker: "Club #1 — Telegram platforma",
    title: "Klub, davomat, to‘lovlar, o‘yinlar va turnirlarni bitta raqamli tizimda boshqaring",
    paragraphs: [
      "Club #1 sport klubining asosiy jarayonlarini birlashtiradi: guruhlar, ishtirokchilar, davomat, hisob-kitoblar, to‘lovlar, o‘yinlar, turnirlar, mukofotlar, media va analitika.",
      "Siz Telegram-botda, smartfondagi Telegram Web App’da va kompyuterdagi oddiy brauzerda ishlashingiz mumkin.",
      "Menejerlar va murabbiylar Telegram-botdan olingan token orqali murakkab avtorizatsiyasiz tizimga kirishlari mumkin.",
      "Club #1 AI sport klublarini topadi hamda menejer, murabbiy va ishtirokchilarning savollariga ularning huquqlari doirasida javob beradi.",
    ],
    button: "Telegram orqali boshlash",
    pills: [
      "Parolsiz",
      "Telegram Web App + brauzer",
      "Davomatni qo‘lda yoki foto orqali belgilash",
      "Turnirlar va o‘yin jamoalari",
      "To‘lovlar va hisob-kitoblar",
      "Analitika va hisobotlar",
      "AI yordamchi va klub qidirish",
    ],
  },

  modules: {
    kicker: "Platforma modullari",
    title: "Klubning barcha asosiy jarayonlari — bitta tizimda",
    text: "Club #1 klub, murabbiylar, ota-onalar va ishtirokchilarning kundalik ishini bitta raqamli makonda jamlashga yordam beradi.",
    cards: [
      { icon: "👥", title: "Klub a’zolari", desc: "Profil, kontaktlar, statuslar, tarix va media." },
      { icon: "🧩", title: "Guruhlar", desc: "Tarkiblar, jadval, murabbiylar va yosh toifalari." },
      { icon: "✅", title: "Davomat", desc: "Qo‘lda belgilash va foto orqali avtomatlashtirish." },
      { icon: "💳", title: "To‘lovlar", desc: "Hisob-kitoblar, qarzdorliklar, cheklar va tasdiqlar." },
      { icon: "⚽", title: "O‘yinlar", desc: "Tarkiblar, ishtirokchilar, natijalar va statistika." },
      { icon: "🏆", title: "Turnirlar", desc: "Tashkil etish, taklifnomalar, jamoalar va ishtirok." },
      { icon: "🎖️", title: "Reyting", desc: "Mukofotlar, yutuqlar, o‘yinchilar va klub reytingi." },
      { icon: "📈", title: "Analitika", desc: "Davomat, to‘lovlar va faollik bo‘yicha hisobotlar." },
      { icon: "🤖", title: "Club #1 AI", desc: "Klublarni qidirish, davomat, to‘lov va a’zolar bo‘yicha rolga mos javoblar." },
    ],
  },

  roles: {
    kicker: "Rollar va kirish huquqlari",
    title: "Har bir rol uchun — o‘z ish ssenariysi",
    items: [
      { title: "Menejer", desc: "Klubni, to‘lovlarni, turnirlarni, mediani va sozlamalarni boshqarish." },
      { title: "Murabbiy", desc: "Davomat, mashg‘ulotlar, tarkiblar, o‘yinlar va turnirlarda ishtirok." },
      { title: "Ota-ona", desc: "Jadval, to‘lovlar, yutuqlar va bolaning bildirishnomalari." },
      { title: "Ishtirokchi", desc: "Profil, o‘yinlar, reyting, mukofotlar va faollik." },
      { title: "SMM", desc: "Ommaviy sahifalar, reyting, mukofotlar va klub kontenti." },
    ],
  },

  attendance: {
    kicker: "Davomat",
    title: "Qo‘lda belgilashdan tortib guruh fotosi orqali yuzni aniqlashgacha",
    paragraphs: [
      "Murabbiy davomatni Telegram tugmalari va veb-kabinet orqali qo‘lda belgilashi mumkin.",
      "Kengaytirilgan rejimda guruh fotosini yuklash mumkin, tizim esa topilgan ishtirokchilarni oldindan belgilab qo‘yadi.",
      "Ishtirokchining oy davomidagi birinchi davomatida hisob-kitob avtomatik yaratilishi mumkin.",
    ],
  },

  tournaments: {
    kicker: "Turnirlar",
    title: "Turnirlar yaratish, klublarni taklif qilish va o‘yin jamoalari",
    text: "Club #1 tizim ichida turnirlar tashkil etishga imkon beradi: klublarni taklif qilish, jamoalarni shakllantirish, o‘yinlar, natijalar va ishtirokni yuritish.",
  },

  rating: {
    kicker: "Reyting va yutuqlar",
    title: "Klub va ishtirokchilarning ochiq sport tarixi",
    text: "Mukofotlar, natijalar, yutuqlar va media klubga bo‘lgan ishonchni oshiradi hamda ota-onalar va o‘yinchilarning qiziqishini kuchaytiradi.",
  },

  analytics: {
    kicker: "Analitika",
    title: "Klub bo‘yicha boshqaruv ko‘rsatkichlari",
    text: "Davomat, to‘lovlar, qarzdorliklar, guruhlar faolligi va klub rivojlanishining umumiy manzarasini kuzating.",
    stats: [
      { value: "24/7", label: "tizimga kirish" },
      { value: "1", label: "yagona platforma" },
      { value: "5+", label: "foydalanuvchi rollari" },
    ],
  },
  ai: {
  "kicker": "Club #1 AI",
  "title": "Sun’iy intellekt bilan klubni boshqaring va to‘garak toping",
  "text": "Telegram orqali savolingizni oddiy tilda yozing. AI klublarni topadi va sizga ruxsat etilgan klub ma’lumotlari bilan ishlashga yordam beradi.",
  "cards": [
    {
      "icon": "🔎",
      "title": "Aqlli klub qidiruvi",
      "desc": "Sport turi, shahar yoki nom bo‘yicha klub toping. Telefon raqamisiz ham izlash mumkin."
    },
    {
      "icon": "💬",
      "title": "Menejer yordamchisi",
      "desc": "Qarzdorlik, a’zolar va davomatni faqat o‘z klubingiz doirasida so‘rang."
    },
    {
      "icon": "🧑‍🏫",
      "title": "Murabbiy va ota-ona uchun",
      "desc": "Rolga mos mashg‘ulotlar, guruhlar va to‘lovlar haqida ma’lumot."
    },
    {
      "icon": "🛟",
      "title": "Jonli yordam",
      "desc": "AI savolni hal qilmasa, Club #1 Support bilan bog‘laning."
    }
  ],
  "button": "Telegram-da AI-ni sinash",
  "searchButton": "Sport klubini topish"
},

  trial: {
  "kicker": "14 kun Pro bepul · sinov muddati",
  "title": "Pro imkoniyatlarini 14 kun bepul sinab ko‘ring",
  "text": "Club #1 klubingizga qanday yordam berishini ko‘ring: AI-yordamchi, foto orqali yuzni tanish, davomat, hisob-kitob va turnirlar. Bank kartasi talab qilinmaydi.",
  "features": [
    "Sinov davrida barcha Pro imkoniyatlari",
    "Sinov vaqtida klubga 100 tagacha AI so‘rovi",
    "Keyin bepul Starter tarifida qolishingiz mumkin"
  ],
  "button": "Telegram orqali sinab ko‘rish",
  "note": "Sinov muddati obuna tizimi ishga tushirilgandan keyin mavjud bo‘ladi. Shartlar va limitlar aniqlashtirilishi mumkin."
},

  priceUi: {
  "monthly": "/ oy",
  "free": "Bepul",
  "country": "Narxni ko‘rsatish valyutasi",
  "localEstimate": "≈ {amount}",
  "fxLoading": "Taxminiy kurs yuklanmoqda…",
  "fxNoRate": "Mahalliy valyutadagi narx hozircha mavjud emas. Asosiy narx — USD.",
  "fxDisclaimer": "Mahalliy summalar ma’lumot uchun kurs asosida taxminan hisoblanadi. Yakuniy to‘lov valyutasi va summasi to‘lovdan oldin ko‘rsatiladi.",
  "ratesAttribution": "Kurs manbasi: Exchange Rate API",
  "offer": "Narxlar ishga tushirish uchun tavsiya etilgan. Pullik obuna, sinov davri va AI-paketlarini xarid qilish keyin qo‘shiladi."
},

  pricing: {
  "kicker": "Tariflar",
  "title": "Har qanday sport klubi uchun qulay tariflar",
  "text": "Bepul Starter-dan Club+ gacha to‘rtta tarif. Sinov ishga tushganda Pro-dan 14 kun bepul foydalaning. Har bir tarifda oylik AI-so‘rovlar limiti bor.",
  "notice": "Narxlar ishga tushirish uchun tavsiya etilgan. Pullik obuna, sinov davri va AI-paketlarini xarid qilish keyin qo‘shiladi.",
  "plans": [
    {
      "name": "Starter",
      "price": "$0",
      "priceUsd": 0,
      "badge": "Kichik klublar uchun",
      "description": "Oylik to‘lovsiz asosiy boshqaruv.",
      "features": [
        "50 tagacha a’zo",
        "Oyiga 50 AI so‘rovi",
        "Guruhlar va jadval",
        "Davomatni qo‘lda belgilash",
        "Hisob-kitob, to‘lov va qarzdorlik",
        "O‘yinlar va tarkiblar"
      ],
      "notIncluded": [
        "Yuzni tanish",
        "Turnirlarda ishtirok",
        "Kengaytirilgan hisobotlar"
      ]
    },
    {
      "name": "Beginner",
      "price": "$12",
      "priceUsd": 12,
      "badge": "O‘sayotgan klublar",
      "description": "Ko‘proq a’zo, turnirlar va hisobotlar.",
      "features": [
        "150 tagacha a’zo",
        "Oyiga 300 AI so‘rovi",
        "Starter imkoniyatlari",
        "Turnirlarda ishtirok",
        "Kengaytirilgan hisobotlar",
        "Yuqoriroq shaxsiy AI limitlari"
      ],
      "notIncluded": [
        "Yuzni tanish",
        "AI tahlili"
      ]
    },
    {
      "name": "Pro",
      "price": "$29",
      "priceUsd": 29,
      "badge": "Faol klublar",
      "highlight": true,
      "description": "Avtomatik davomat va AI tahlili.",
      "features": [
        "500 tagacha a’zo",
        "Oyiga 1 500 AI so‘rovi",
        "Beginner imkoniyatlari",
        "Foto orqali yuzni tanish",
        "AI tahlili",
        "Kengaytirilgan hisobotlar"
      ],
      "notIncluded": []
    },
    {
      "name": "Club+",
      "price": "$59",
      "priceUsd": 59,
      "badge": "Akademiyalar uchun",
      "description": "Yirik sport tashkilotlari uchun maksimal imkoniyat.",
      "features": [
        "A’zolar soniga qat’iy cheklov yo‘q",
        "Oyiga 2 000 AI so‘rovi",
        "Pro imkoniyatlari",
        "Yuzni tanish",
        "Turnirlar va AI tahlili",
        "Kengaytirilgan hisobotlar"
      ],
      "notIncluded": []
    }
  ]
},

  packages: {
  "kicker": "Qo‘shimcha AI",
  "title": "Yana AI so‘rovlari kerakmi?",
  "text": "Klubning oylik AI-limiti yetmasa, qo‘shimcha so‘rovlar paketini xarid qilish mumkin. Xarid to‘lov tizimi ishga tushganda mavjud bo‘ladi.",
  "cards": [
    {
      "name": "AI 100",
      "price": "$5",
      "priceUsd": 5,
      "detail": "100 ta qo‘shimcha AI so‘rovi"
    },
    {
      "name": "AI 500",
      "price": "$19",
      "priceUsd": 19,
      "detail": "500 ta qo‘shimcha AI so‘rovi"
    },
    {
      "name": "AI 1500",
      "price": "$45",
      "priceUsd": 45,
      "detail": "1 500 ta qo‘shimcha AI so‘rovi"
    }
  ],
  "note": "Narxlar tavsiya etilgan. Paketlarni xarid qilish hali yoqilmagan; shartlar keyin aniqlanadi.",
  "button": "Xarid shartlarini bilish"
},

  referral: {
  "kicker": "Taklif dasturi · tez kunda",
  "title": "Klub taklif qiling — birinchi to‘lovining 100%ini oling",
  "text": "Club #1-ga yangi sport klubini taklif qiling. U sinov muddatidan keyin obuna uchun ilk bor to‘lov qilgach, shu to‘lovning 100%iga teng bonus ichki Club #1 balansingizga qo‘shiladi.",
  "steps": [
    "Tanish klubni taklif qiling",
    "Klub ro‘yxatdan o‘tib, ilk to‘lovini qiladi",
    "Shu summaga teng bonusni Club #1 balansiga oling"
  ],
  "note": "Dastur oldindan e’lon qilingan. Bonuslarni hisoblash va ishlatish qoidalari ishga tushgach mavjud bo‘ladi. Bonus — ichki balans, naqd pul emas.",
  "button": "Ishga tushish haqida bilish"
},

  faq: {
  kicker: "FAQ",
  title: "Ko‘p beriladigan savollar",
  items: [
    {
      q: "Ilova o‘rnatish kerakmi?",
      a: "Yo‘q. Club #1 Telegram-botda, Telegram Web App’da va oddiy brauzerda ishlaydi.",
    },
    {
      q: "To‘lovlar va davomatni yuritish mumkinmi?",
      a: "Ha. Bu tizimning asosiy ssenariylaridan biridir.",
    },
    {
      q: "Turnirlar uchun mosmi?",
      a: "Ha. Turnirlar yaratish, klublarni taklif qilish va o‘yin jamoalarini shakllantirish mumkin.",
    },
    {
      q: "Bu tizim kimlar uchun?",
      a: "Sport klublari, akademiyalar, murabbiylar va turnir tashkilotchilari uchun — ishtirokchilar, to‘lovlar, o‘yinlar va o‘yinchilar rivojini bitta tizimda boshqarish uchun.",
    },
    {
      q: "Yana savollaringiz bormi?",
      a: "Qo‘llab-quvvatlashga yozing: <a href='https://t.me/club1_support' target='_blank'>@Club1 Support</a>",
    },

    {
      "q": "AI qaysi tillarda javob beradi?",
      "a": "Club #1 AI o‘zbek, qirg‘iz, rus va boshqa qo‘llab-quvvatlangan tillardagi so‘rovlarni tushunadi. Ommaviy qidiruv va klubning ichki ma’lumotlari ajratilgan."
    },
    {
      "q": "AI limitlari qanday ishlaydi?",
      "a": "Har bir tarifda klub uchun umumiy oylik AI so‘rov limiti va rollar bo‘yicha shaxsiy limitlar mavjud. Ommaviy qidiruv klub limitini sarflamaydi."
    },
    {
      "q": "Qo‘shimcha AI so‘rovlari sotib olsam bo‘ladimi?",
      "a": "Qo‘shimcha AI paketlari ko‘zda tutilgan. Xarid shartlarini <a href=\"https://t.me/club1_support\" target=\"_blank\" rel=\"noopener noreferrer\">Club #1 Support</a> orqali aniqlang."
    },
    {
      "q": "«Klub taklif qiling» aksiyasi boshlandimi?",
      "a": "Taklif dasturi e’lon qilingan, ammo bonuslarni avtomatik hisoblash hali ishlab chiqilmoqda."
    },
    {
      "q": "Bepul sinov muddati bormi?",
      "a": "Yangi klublar uchun bank kartasisiz 14 kunlik Pro sinovi rejalashtirilgan. Bu imkoniyat obuna tizimi bilan birga ishga tushadi. Keyin bepul Starter tarifidan foydalanish mumkin."
    },
    {
      "q": "Narxlar qaysi valyutada ko‘rsatilgan?",
      "a": "Asosiy narx AQSH dollarida (USD). Mamlakatni tanlab, KGS, RUB, KZT yoki UZSda taxminiy summani ko‘rishingiz mumkin. Yakuniy to‘lov summasi oldindan tasdiqlanadi."
    }
  ],
},

  cta: {
    kicker: "Boshlashga tayyormisiz?",
    title: "Club #1 ni Telegram’da sinab ko‘ring",
    text: "Club #1-ni Telegram-da oching: klubni boshqaring, sport to‘garagini toping yoki AI yordamchisini sinang.",
    button: "Botni ochish",
  },

  footer: {
    text: "Sport klublari uchun raqamli platforma",
  },
};

const kzText = {
  nav: [
    { id: "modules", label: "Модульдер" },
    { id: "roles", label: "Рөлдер" },
    { id: "tournaments", label: "Турнирлер" },
    { id: "trial", label: "14 күн тегін" },
    { id: "pricing", label: "Тарифтер" },
    { id: "faq", label: "FAQ" },
    { id: "ai", label: "ЖИ" },
    { id: "referral", label: "Акция" },
  ],

  hero: {
    kicker: "Club #1 — Telegram платформасы",
    title: "Клубты, қатысуды, төлемдерді, ойындар мен турнирлерді бір цифрлық жүйеде басқарыңыз",
    paragraphs: [
      "Club #1 спорт клубының негізгі процестерін біріктіреді: топтар, қатысушылар, қатысу, есептеулер, төлемдер, ойындар, турнирлер, марапаттар, медиа және аналитика.",
      "Сіз Telegram-ботта, смартфондағы Telegram Web App-та және компьютердегі кәдімгі браузерде жұмыс істей аласыз.",
      "Менеджерлер мен жаттықтырушылар Telegram-боттан алынған токен арқылы күрделі авторизациясыз кіре алады.",
      "Club #1 AI спорт клубтарын табуға және менеджерлер, жаттықтырушылар мен қатысушылардың сұрақтарына құқықтарына сәйкес жауап беруге көмектеседі.",
    ],
    button: "Telegram арқылы бастау",
    pills: [
      "Құпиясөзсіз",
      "Telegram Web App + браузер",
      "Қатысуды қолмен немесе фото арқылы белгілеу",
      "Турнирлер мен ойын командалары",
      "Төлемдер мен есептеулер",
      "Аналитика және есептер",
      "ЖИ-көмекші және клуб іздеу",
    ],
  },

  modules: {
    kicker: "Платформа модульдері",
    title: "Клубтың барлық негізгі процестері — бір жүйеде",
    text: "Club #1 клубтың, жаттықтырушылардың, ата-аналардың және қатысушылардың күнделікті жұмысын бір цифрлық кеңістікте жинақтауға көмектеседі.",
    cards: [
      { icon: "👥", title: "Клуб мүшелері", desc: "Профильдер, байланыстар, мәртебелер, тарих және медиа." },
      { icon: "🧩", title: "Топтар", desc: "Құрамдар, кесте, жаттықтырушылар және жас санаттары." },
      { icon: "✅", title: "Қатысу", desc: "Қолмен белгілеу және фото арқылы автоматтандыру." },
      { icon: "💳", title: "Төлемдер", desc: "Есептеулер, қарыздар, түбіртектер және растаулар." },
      { icon: "⚽", title: "Ойындар", desc: "Құрамдар, қатысушылар, нәтижелер және статистика." },
      { icon: "🏆", title: "Турнирлер", desc: "Ұйымдастыру, шақырулар, командалар және қатысу." },
      { icon: "🎖️", title: "Рейтинг", desc: "Марапаттар, жетістіктер, ойыншылар мен клуб рейтингі." },
      { icon: "📈", title: "Аналитика", desc: "Қатысу, төлемдер және белсенділік бойынша есептер." },
      { icon: "🤖", title: "Club #1 AI", desc: "Клуб іздеу, қатысу, төлемдер және қатысушылар туралы рөлге сай жауаптар." },
    ],
  },

  roles: {
    kicker: "Рөлдер мен қолжетімділік",
    title: "Әр рөлге — өз жұмыс сценарийі",
    items: [
      { title: "Менеджер", desc: "Клубты, төлемдерді, турнирлерді, медианы және баптауларды басқару." },
      { title: "Жаттықтырушы", desc: "Қатысу, жаттығулар, құрамдар, ойындар және турнирлерге қатысу." },
      { title: "Ата-ана", desc: "Кесте, төлемдер, жетістіктер және баланың хабарламалары." },
      { title: "Қатысушы", desc: "Профиль, ойындар, рейтинг, марапаттар және белсенділік." },
      { title: "SMM", desc: "Қоғамдық парақшалар, рейтинг, марапаттар және клуб контенті." },
    ],
  },

  attendance: {
    kicker: "Қатысу",
    title: "Қолмен белгілеуден топтық фото арқылы бет-әлпетті тануға дейін",
    paragraphs: [
      "Жаттықтырушы қатысуды Telegram батырмалары және веб-кабинет арқылы қолмен белгілей алады.",
      "Кеңейтілген режимде топтық фото жүктеуге болады, ал жүйе табылған қатысушыларды алдын ала белгілеп қояды.",
      "Қатысушының ай ішіндегі алғашқы қатысуында есептеу автоматты түрде жасалуы мүмкін.",
    ],
  },

  tournaments: {
    kicker: "Турнирлер",
    title: "Турнирлер құру, клубтарды шақыру және ойын командалары",
    text: "Club #1 жүйе ішінде турнирлер ұйымдастыруға мүмкіндік береді: клубтарды шақыруға, командаларды жинауға, ойындарды, нәтижелерді және қатысуды жүргізуге.",
  },

  rating: {
    kicker: "Рейтинг және жетістіктер",
    title: "Клуб пен қатысушылардың ашық спорттық тарихы",
    text: "Марапаттар, нәтижелер, жетістіктер және медиа клубқа деген сенімді арттырып, ата-аналар мен ойыншылардың қызығушылығын күшейтеді.",
  },

  analytics: {
    kicker: "Аналитика",
    title: "Клуб бойынша басқарушылық көрсеткіштер",
    text: "Қатысуды, төлемдерді, қарыздарды, топтардың белсенділігін және клуб дамуының жалпы көрінісін бақылаңыз.",
    stats: [
      { value: "24/7", label: "жүйеге қолжетімділік" },
      { value: "1", label: "бірыңғай платформа" },
      { value: "5+", label: "пайдаланушы рөлдері" },
    ],
  },
  ai: {
  "kicker": "Club #1 AI",
  "title": "Жасанды интеллектпен клубты басқарыңыз және секция табыңыз",
  "text": "Telegram-да сұрағыңызды күнделікті тілмен қойыңыз. ЖИ клубтарды іздеп, сізге қолжетімді клуб мәліметтерімен жұмыс істеуге көмектеседі.",
  "cards": [
    {
      "icon": "🔎",
      "title": "Ақылды клуб іздеу",
      "desc": "Спорт түрі, қала немесе атау бойынша клуб табыңыз. Телефон нөмірінсіз де іздеуге болады."
    },
    {
      "icon": "💬",
      "title": "Менеджер көмекшісі",
      "desc": "Қарыздар, қатысушылар және келушілер туралы тек өз клубыңыз бойынша сұраңыз."
    },
    {
      "icon": "🧑‍🏫",
      "title": "Жаттықтырушы мен ата-анаға",
      "desc": "Рөлге сәйкес жаттығулар, топтар және төлемдер туралы ақпарат."
    },
    {
      "icon": "🛟",
      "title": "Тікелей қолдау",
      "desc": "ЖИ жауап бере алмаса, Club #1 Support қызметіне жазыңыз."
    }
  ],
  "button": "Telegram-да ЖИ-ді сынау",
  "searchButton": "Спорт клубын табу"
},

  trial: {
  "kicker": "14 күн Pro тегін · сынақ мерзімі",
  "title": "Pro мүмкіндіктерін 14 күн тегін байқап көріңіз",
  "text": "Club #1 клубыңызға қалай көмектесетінін тексеріңіз: AI-көмекші, фотодан бет-әлпетті тану, қатысу, төлем есептері және турнирлер. Банк картасы қажет емес.",
  "features": [
    "Сынақ кезінде барлық Pro мүмкіндіктері",
    "Сынақ мерзімінде клубқа 100-ге дейін AI-сұрау",
    "Соңында тегін Starter тарифінде қала аласыз"
  ],
  "button": "Telegram арқылы бастау",
  "note": "Сынақ мерзімі жазылым жүйесі іске қосылғаннан кейін қолжетімді болады. Шарттар мен лимиттер нақтылануы мүмкін."
},

  priceUi: {
  "monthly": "/ ай",
  "free": "Тегін",
  "country": "Бағаны көрсету валютасы",
  "localEstimate": "≈ {amount}",
  "fxLoading": "Бағам жүктелуде…",
  "fxNoRate": "Жергілікті валютадағы баға әзірше қолжетімсіз. Негізгі баға — USD.",
  "fxDisclaimer": "Жергілікті сомалар анықтамалық бағаммен шамамен есептеледі. Нақты төлем валютасы мен сомасы төлем алдында көрсетіледі.",
  "ratesAttribution": "Бағам көзі: Exchange Rate API",
  "offer": "Бағалар іске қосуға ұсынылған. Ақылы жазылымдар, сынақ мерзімі және AI-пакеттерді сатып алу кейін қосылады."
},

  pricing: {
  "kicker": "Тарифтер",
  "title": "Әр спорт клубына арналған ыңғайлы тарифтер",
  "text": "Тегін Starter-ден Club+ тарифіне дейін төрт жоспар. Сынақ іске қосылғанда Pro-ды 14 күн тегін пайдаланыңыз. Әр тарифте айлық AI-сұрау лимиті бар.",
  "notice": "Бағалар іске қосуға ұсынылған. Ақылы жазылымдар, сынақ мерзімі және AI-пакеттерді сатып алу кейін қосылады.",
  "plans": [
    {
      "name": "Starter",
      "price": "$0",
      "priceUsd": 0,
      "badge": "Шағын клубтарға",
      "description": "Айлық төлемсіз негізгі басқару.",
      "features": [
        "50 қатысушыға дейін",
        "Айына 50 ЖИ-сұрау",
        "Топтар мен кестелер",
        "Қатысуды қолмен белгілеу",
        "Есептеулер, төлемдер мен қарыздар",
        "Ойындар мен құрамдар"
      ],
      "notIncluded": [
        "Бетті тану",
        "Турнирлерге қатысу",
        "Кеңейтілген есептер"
      ]
    },
    {
      "name": "Beginner",
      "price": "$12",
      "priceUsd": 12,
      "badge": "Өсіп келе жатқан клубтарға",
      "description": "Көбірек қатысушы, турнирлер және есептер.",
      "features": [
        "150 қатысушыға дейін",
        "Айына 300 ЖИ-сұрау",
        "Starter мүмкіндіктері",
        "Турнирлерге қатысу",
        "Кеңейтілген есептер",
        "Жеке ЖИ-лимиттері жоғары"
      ],
      "notIncluded": [
        "Бетті тану",
        "ЖИ-аналитика"
      ]
    },
    {
      "name": "Pro",
      "price": "$29",
      "priceUsd": 29,
      "badge": "Белсенді клубтарға",
      "highlight": true,
      "description": "Автоматты қатысу және ЖИ-аналитика.",
      "features": [
        "500 қатысушыға дейін",
        "Айына 1 500 ЖИ-сұрау",
        "Beginner мүмкіндіктері",
        "Фото арқылы бетті тану",
        "ЖИ-аналитика",
        "Кеңейтілген есептер"
      ],
      "notIncluded": []
    },
    {
      "name": "Club+",
      "price": "$59",
      "priceUsd": 59,
      "badge": "Академиялар үшін",
      "description": "Ірі спорт ұйымдарына барынша мүмкіндік.",
      "features": [
        "Қатысушыларға нақты шектеу жоқ",
        "Айына 2 000 ЖИ-сұрау",
        "Pro мүмкіндіктері",
        "Бетті тану",
        "Турнирлер мен ЖИ-аналитика",
        "Кеңейтілген есептер"
      ],
      "notIncluded": []
    }
  ]
},

  packages: {
  "kicker": "Қосымша ЖИ",
  "title": "Тағы ЖИ-сұраулар керек пе?",
  "text": "Клубтың айлық AI лимиті жетпесе, қосымша сұраулар пакетін сатып алуға болады. Сатып алу төлем жүйесі қосылғанда іске асады.",
  "cards": [
    {
      "name": "AI 100",
      "price": "$5",
      "priceUsd": 5,
      "detail": "100 қосымша ЖИ-сұрау"
    },
    {
      "name": "AI 500",
      "price": "$19",
      "priceUsd": 19,
      "detail": "500 қосымша ЖИ-сұрау"
    },
    {
      "name": "AI 1500",
      "price": "$45",
      "priceUsd": 45,
      "detail": "1 500 қосымша ЖИ-сұрау"
    }
  ],
  "note": "Бағалар іске қосу үшін ұсынылған. Пакеттерді сатып алу әлі қосылмаған; шарттар кейін нақтыланады.",
  "button": "Сатып алу шарттарын білу"
},

  referral: {
  "kicker": "Шақыру бағдарламасы · жақында",
  "title": "Клуб шақыр — алғашқы төлемінің 100%-ын ал",
  "text": "Club #1-ге жаңа спорт клубын шақырыңыз. Ол сынақ мерзімінен кейін жазылымды алғаш рет төлегенде, осы төлемнің 100%-ына тең бонус Club #1 ішкі балансыңызға түседі.",
  "steps": [
    "Таныс спорт клубын шақырыңыз",
    "Клуб тіркеліп, алғашқы төлемін жасайды",
    "Сол сомаға тең бонусты Club #1 балансына алыңыз"
  ],
  "note": "Бағдарлама алдын ала жарияланды. Бонустарды есептеу мен қолдану ережелері іске қосылғаннан кейін қолжетімді болады. Бонус — ішкі баланс, қолма-қол ақша емес.",
  "button": "Іске қосылуын білу"
},

  faq: {
  kicker: "FAQ",
  title: "Жиі қойылатын сұрақтар",
  items: [
    {
      q: "Қосымша орнату керек пе?",
      a: "Жоқ. Club #1 Telegram-ботта, Telegram Web App-та және кәдімгі браузерде жұмыс істейді.",
    },
    {
      q: "Төлемдер мен қатысуды жүргізуге бола ма?",
      a: "Иә. Бұл жүйенің негізгі сценарийлерінің бірі.",
    },
    {
      q: "Турнирлерге жарай ма?",
      a: "Иә. Турнирлер құруға, клубтарды шақыруға және ойын командаларын жинауға болады.",
    },
    {
      q: "Бұл жүйе кімдерге арналған?",
      a: "Спорт клубтары, академиялар, жаттықтырушылар және турнир ұйымдастырушылары үшін — қатысушыларды, төлемдерді, ойындарды және ойыншылардың дамуын бір жүйеде басқару үшін.",
    },
    {
      q: "Тағы сұрақтарыңыз бар ма?",
      a: "Қолдау қызметіне жазыңыз: <a href='https://t.me/club1_support' target='_blank'>@Club1 Support</a>",
    },

    {
      "q": "ЖИ қай тілдерде жауап береді?",
      "a": "Club #1 AI қазақ, қырғыз, орыс және басқа қолдау көрсетілетін тілдердегі сұрақтарды түсінеді. Клуб іздеу мен ішкі мәліметтер бөлек өңделеді."
    },
    {
      "q": "ЖИ-лимиттері қалай жұмыс істейді?",
      "a": "Әр тарифте клубтың жалпы айлық ЖИ-сұрау лимиті және рөлдерге арналған жеке лимиттер бар. Ашық іздеу клуб лимитін жұмсамайды."
    },
    {
      "q": "Қосымша ЖИ-сұраулар сатып алуға бола ма?",
      "a": "Қосымша ЖИ-пакеттері ұсынылады. Сатып алу шарттарын <a href=\"https://t.me/club1_support\" target=\"_blank\" rel=\"noopener noreferrer\">Club #1 Support</a> қызметінен біліңіз."
    },
    {
      "q": "«Клуб шақыр» акциясы іске қосылды ма?",
      "a": "Шақыру бағдарламасы жарияланды, бірақ бонустарды автоматты есептеу әзірленуде."
    },
    {
      "q": "Тегін сынақ мерзімі бар ма?",
      "a": "Жаңа клубтарға банк картасынсыз 14 күн Pro сынақ мерзімі жоспарланған. Бұл мүмкіндік жазылым жүйесімен бірге іске қосылады. Содан кейін тегін Starter пайдалануға болады."
    },
    {
      "q": "Бағалар қандай валютада көрсетілген?",
      "a": "Негізгі баға АҚШ долларында (USD). Елді таңдап, KGS, RUB, KZT немесе UZS бойынша шамамен құнын көре аласыз. Түпкілікті сома төлем алдында расталады."
    }
  ],
},

  cta: {
    kicker: "Бастауға дайынсыз ба?",
    title: "Club #1-ді Telegram-да қолданып көріңіз",
    text: "Club #1 жүйесін Telegram-да ашыңыз: клубты басқарыңыз, спорт секциясын табыңыз немесе AI-көмекшіні байқап көріңіз.",
    button: "Ботты ашу",
  },

  footer: {
    text: "Спорт клубтарына арналған цифрлық платформа",
  },
};

function makeConfig(texts, screens) {
  return {
    nav: texts.nav,

    hero: {
      kicker: texts.hero.kicker,
      title: texts.hero.title,
      paragraphs: texts.hero.paragraphs,
      button: texts.hero.button,
      pills: texts.hero.pills,
      image: screens.hero,
    },

    modules: {
      kicker: texts.modules.kicker,
      title: texts.modules.title,
      text: texts.modules.text,
      cards: texts.modules.cards,
      screens: screens.modules,
    },

    roles: {
      kicker: texts.roles.kicker,
      title: texts.roles.title,
      items: texts.roles.items,
      screens: screens.roles,
    },

    attendance: {
      kicker: texts.attendance.kicker,
      title: texts.attendance.title,
      paragraphs: texts.attendance.paragraphs,
      screens: screens.attendance,
    },

    tournaments: {
      kicker: texts.tournaments.kicker,
      title: texts.tournaments.title,
      text: texts.tournaments.text,
      screens: screens.tournaments,
    },

    rating: {
      kicker: texts.rating.kicker,
      title: texts.rating.title,
      text: texts.rating.text,
      screens: screens.rating,
    },

    analytics: {
      kicker: texts.analytics.kicker,
      title: texts.analytics.title,
      text: texts.analytics.text,
      stats: texts.analytics.stats,
      screens: screens.analytics,
    },

    ai: texts.ai,

    trial: texts.trial,
    priceUi: texts.priceUi,
    pricing: texts.pricing,

    packages: texts.packages,

    referral: texts.referral,

    faq: {
      kicker: texts.faq.kicker,
      title: texts.faq.title,
      items: texts.faq.items,
    },

    cta: {
      kicker: texts.cta.kicker,
      title: texts.cta.title,
      text: texts.cta.text,
      button: texts.cta.button,
    },

    footer: {
      brand: "Club #1",
      text: texts.footer.text,
    },
  };
}

export const LANDING_CONFIG = {
  ru: makeConfig(ruText, screensByLang.ru),
  kg: makeConfig(kgText, screensByLang.kg),
  kz: makeConfig(kzText, screensByLang.kz),
  uz: makeConfig(uzText, screensByLang.uz),
  en: makeConfig(enText, screensByLang.en),
};